var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var uuid_1 = require("../../util/uuid");
var types_1 = require("./types");
exports.triggerNotification = typesafe_actions_1.createAction(types_1.NotificationsActionTypes.TRIGGER_NOTIFICATION, function (resolve) { return function (notification) { return resolve({
    notification: __assign({ id: uuid_1.default(), type: 'default' }, notification),
}); }; });
exports.closeNotification = function (notificationId) { return typesafe_actions_1.action(types_1.NotificationsActionTypes.CLOSE_NOTIFICATION, {
    notificationId: notificationId,
}); };
